import * as fetchReservations from 'store/actions/reservations/fetchReservations';
import * as exportReservations from 'store/actions/reservations/exportReservations';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { push } from 'react-router-redux';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchReservationsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/reservations`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchReservations.fetchReservationsSuccess(response));
    } catch (error) {
        yield put(fetchReservations.fetchReservationsFailure(error));
    }
}

function* fetchReservationAsync({ payload }) {
    const { id } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/reservations/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchReservations.fetchReservationSuccess(response));
    } catch (error) {
        yield put(fetchReservations.fetchReservationFailure(error));
    }
}

function* exportReservationAsync({ params }) {
    try {
        const url = `${ config.getApiBaseUrl() }/reservations/export`;

        yield apiClient.read(url, params);

        yield put(exportReservations.exportReservationSuccess());
    } catch (error) {
        yield put(exportReservations.exportReservationFailure());
    }
}

function* exportReservationFailureAsync() {
    yield put(showNotification('notifications.export.failure'));
}

function* exportReservationSuccessAsync() {
    yield put(showNotification('notifications.export.success'));
}

function* failureMessage({ error }) {
    const { code, message } = error.response;

    if (code === 404) {
        yield put(push('/reservations'));
    }

    yield put(showNotification(message, 'warning'));
}

export default function* usersSagas() {
    yield [
        takeEvery(types.FETCH_RESERVATIONS, fetchReservationsAsync),
        takeEvery(types.FETCH_RESERVATIONS_FAILURE, failureMessage),

        takeEvery(types.FETCH_RESERVATION, fetchReservationAsync),
        takeEvery(types.FETCH_RESERVATION_FAILURE, failureMessage),

        takeEvery(types.RESERVATION_EXPORT, exportReservationAsync),
        takeEvery(types.RESERVATION_EXPORT_FAILURE, exportReservationFailureAsync),
        takeEvery(types.RESERVATION_EXPORT_SUCCESS, exportReservationSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/reservationsSagas.js